import { Skeleton } from "antd"
import { SkeletonButtonProps } from "antd/lib/skeleton/Button"
import React from "react"

interface LoadingDataProps extends SkeletonButtonProps {}

const LoadingData = ({ size, active, ...rest }: LoadingDataProps) => <Skeleton.Button size={size ?? "small"} active={active ?? true} {...rest} />

export default LoadingData
